import TicketDetailsRecommendations from './TicketDetailsRecommendations';

export default TicketDetailsRecommendations;
